export const termsContent = {
  title: "Terms of Service",
  lastUpdated: "Updated: Oct 2026",
  sections: [
    {
      heading: "1. Agreement to Terms",
      text: "By accessing or using our eCommerce platform, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the service or complete any purchases."
    },
    {
      heading: "2. User Accounts and Responsibilities",
      text: "When you create an account with us, you must provide accurate, complete, and current information. You are entirely responsible for maintaining the confidentiality of your password and account. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account."
    },
    {
      heading: "3. Product Availability and Pricing",
      text: "We reserve the right to modify or discontinue any product without notice at any time. Prices for our products are subject to change without notice. We shall not be liable to you or to any third party for any modification, price change, suspension, or discontinuance of the service."
    },
    {
      heading: "4. Intellectual Property",
      text: "The Service and its original content, features, and functionality are and will remain the exclusive property of our company and its licensors. Our branding, logos, and digital assets may not be used in connection with any product or service without our prior written consent."
    }
  ]
};

export const privacyContent = {
  title: "Privacy Policy",
  lastUpdated: "Updated: Oct 2026",
  sections: [
    {
      heading: "1. Information Collection",
      text: "We collect information you provide directly to us when making a purchase, creating an account, or signing up for our newsletter. This includes your name, email address, postal address, payment information, and phone number."
    },
    {
      heading: "2. Use of Information",
      text: "The information we collect is used strictly to process transactions, provide customer support, and send periodic promotional emails if you have opted in. We use industry-standard encryption to protect your sensitive data during transmission."
    },
    {
      heading: "3. Third-Party Sharing",
      text: "We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties. This does not include trusted third parties who assist us in operating our website, conducting our business, or servicing you, so long as those parties agree to keep this information confidential."
    },
    {
      heading: "4. Cookie Tracking",
      text: "Our platform utilizes cookies to enhance your browsing experience, remember your cart items, and understand your preferences based on previous site activity. You can choose to have your computer warn you each time a cookie is being sent, or you can turn off all cookies in your browser settings."
    }
  ]
};

export const returnsContent = {
  title: "Return & Refund Policy",
  lastUpdated: "Updated: Oct 2026",
  sections: [
    {
      heading: "1. 30-Day Return Window",
      text: "Our policy lasts 30 days. If 30 days have gone by since your purchase, unfortunately, we cannot offer you a refund or exchange. To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging."
    },
    {
      heading: "2. Non-returnable Items",
      text: "Several types of goods are exempt from being returned. Perishable goods, intimates, and gift cards cannot be returned. We also do not accept products that are intimate or sanitary goods, hazardous materials, or downloadable software products."
    },
    {
      heading: "3. Refund Processing",
      text: "Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. If approved, your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment within 5-10 business days."
    },
    {
      heading: "4. Shipping Costs",
      text: "You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund."
    }
  ]
};
